import React from 'react';
import App from './App';
import {AppContextProvider} from './ContextProvider';

export const Wrapper = () => <AppContextProvider>
    <App/>
</AppContextProvider>;